import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";

axios.defaults.timeout = 30000;

// Polyfill/patch ResizeObserver to prevent "ResizeObserver loop" errors
// This error is harmless and occurs with Radix UI components (Popover, Combobox)
// The error appears in React's error overlay but doesn't affect functionality
const originalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends originalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      // Wrap callback in requestAnimationFrame to prevent loop errors
      window.requestAnimationFrame(() => {
        try {
          callback(entries, observer);
        } catch (e) {
          // Silently ignore ResizeObserver errors
        }
      });
    });
  }
};

// Also suppress the error at console level
const originalError = console.error;
console.error = (...args) => {
  if (args[0] && typeof args[0] === 'string' && args[0].includes('ResizeObserver')) {
    return;
  }
  originalError.apply(console, args);
};

// Suppress in window.onerror
window.onerror = (message, source, lineno, colno, error) => {
  if (message && message.toString().includes('ResizeObserver')) {
    return true;
  }
  return false;
};

// Suppress in unhandledrejection
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message && event.reason.message.includes('ResizeObserver')) {
    event.preventDefault();
  }
});

// Suppress in error event listener (capture phase to get it before React)
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('ResizeObserver')) {
    event.preventDefault();
    event.stopImmediatePropagation();
    return false;
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
